import { render, staticRenderFns } from "./AllNotes.vue?vue&type=template&id=f90d626a"
import script from "./AllNotes.vue?vue&type=script&lang=js"
export * from "./AllNotes.vue?vue&type=script&lang=js"
import style0 from "./AllNotes.vue?vue&type=style&index=0&id=f90d626a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports